export default __webpack_public_path__ + "static/media/h2.d0e68b06.png";